<template>
    <SOSlotBase :bg-white="true" :loading="pageSetting.loading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="pageSetting.pageTitle" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div v-if="!pageSetting.loading">
                <div class="p-x-20 p-y-16">
                    <div class="f-regular f-12 f-c-red m-d-4">
                        Pengeluaran biaya
                    </div>
                    <div class="f-bold f-18 f-c-black m-d-8">Biaya Transaksi {{ biaya.main_data.workshop.nama }}</div>
                    <div class="f-regular f-12 f-c-midgrey">
                        <img src="@/assets/icons/clock.svg" alt="" />
                        <span class="m-l-4">
                            Dibuat {{ biaya.time_data.waktu_dibuat_formated }} oleh
                            {{ biaya.main_data.karyawan ? biaya.main_data.karyawan.nama : "-" }}
                        </span>
                    </div>
                </div>

                <div class="separator-line-dot"></div>

                <div
                    v-if="biaya.main_data.status !== 1"
                    class="p-x-20 p-y-12"
                    :class="{
                        'biaya-disetujui': biaya.main_data.status === 2,
                        'biaya-ditolak': biaya.main_data.status === 3,
                    }"
                >
                    <div class="f-c-green" v-if="biaya.main_data.status === 2">
                        <span class="f-semi f-14">Permintaan Disetujui </span>
                        <span class="f-semi f-12"
                            >({{ $moment(biaya.time_data.waktu_konfirmasi).format("DD MMM YYYY HH:mm:ss") }})</span
                        >
                    </div>
                    <div class="f-c-red" v-if="biaya.main_data.status === 3">
                        <span class="f-semi f-14">Permintaan Ditolak </span>
                        <span class="f-semi f-12"
                            >({{ $moment(biaya.time_data.waktu_konfirmasi).format("DD MMM YYYY HH:mm:ss") }})</span
                        >
                    </div>
                    <div class="f-regular f-13" v-if="biaya.main_data.keterangan_status">
                        <span class="f-c-midgrey">Catatan: </span>
                        <span class="f-c-black">
                            {{ biaya.main_data.keterangan_status }}
                        </span>
                    </div>
                </div>

                <div class="p-x-20 p-y-16">
                    <div class="d-flex-between-center m-d-8">
                        <div class="f-regular f-16 f-c-midgrey">
                            Sumber dana
                        </div>
                        <div class="f-regular f-16 f-c-black">
                            {{ biaya.main_data.akun_kredit.nama_akun }}
                        </div>
                    </div>
                    <div class="d-flex-between-center m-d-8">
                        <div class="f-regular f-16 f-c-midgrey">
                            Penanggung jawab
                        </div>
                        <div class="f-regular f-16 f-c-black">
                            {{ biaya.main_data.karyawan ? biaya.main_data.karyawan.nama : "-" }}
                        </div>
                    </div>
                    <div class="d-flex-between-center m-d-8">
                        <div class="f-regular f-16 f-c-midgrey">
                            Nominal
                        </div>
                        <div class="f-regular f-16 f-c-black">Rp {{ formatRupiah(biaya.main_data.nominal) }}</div>
                    </div>
                    <div class="d-flex-between-center m-d-8">
                        <div class="f-regular f-16 f-c-midgrey">
                            Waktu pemakaian
                        </div>
                        <div class="f-regular f-16 f-c-black">
                            {{ biaya.time_data.waktu_pemakaian_formated }}
                        </div>
                    </div>
                    <div class="p-y-8 m-d-8">
                        <div class="card-biaya">
                            <div class="d-flex-between-center">
                                <div class="f-regular f-14 f-c-midgrey">
                                    Akun biaya:
                                </div>
                                <div class="f-regular f-14 f-c-midgrey">
                                    {{ biaya.main_data.biaya_item.biaya_kategori.nama }}
                                </div>
                            </div>
                            <div class="d-flex-between-center m-t-4 p-t-8">
                                <div class="f-regular f-14 f-c-midgrey">
                                    Item biaya:
                                </div>
                                <div class="f-regular f-14 f-c-midgrey">
                                    {{ biaya.main_data.biaya_item.nama }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="f-c-midgrey p-x-12 p-y-16 bg-gray"
                    :class="{
                        'p-d-72': biaya.main_data.keterangan_status === '',
                        'p-d-16': biaya.main_data.keterangan_status !== '',
                    }"
                    v-if="biaya.transaksi_foto.length > 0"
                >
                    <div class="f-regular f-14 p-x-8">Bukti pengeluaran</div>
                    <div class="img-wrapper" v-if="true">
                        <div class="img-container" v-for="(foto, i) in biaya.transaksi_foto" :key="`${i}-nota`">
                            <div
                                class="img-biaya"
                                v-if="!foto.cloud_thumb"
                                style="width: 80px; height: 80px; background-position: center; background-size: cover"
                                :style="{
                                    backgroundImage:
                                        'url(' + baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name + ')',
                                }"
                                @click="
                                    previewPhoto(
                                        baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name,
                                        foto.cloud_content_type
                                    )
                                "
                            ></div>
                            <div
                                class="img-biaya"
                                v-else
                                style="width: 80px; height: 80px; background-position: center; background-size: cover"
                                :style="{
                                    backgroundImage:
                                        'url(' + baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_thumb + ')',
                                }"
                                @click="
                                    previewPhoto(
                                        baseUrlCloudBucket + foto.cloud_bucket + '/' + foto.cloud_name,
                                        foto.cloud_content_type
                                    )
                                "
                            ></div>
                        </div>
                    </div>
                </div>

                <div class="p-x-20 p-x-20 p-t-16 p-d-72" v-if="biaya.main_data.keterangan !== ''">
                    <div class="f-regular f-14 f-c-midgrey">Keterangan</div>
                    <div class="f-regular f-14 f-c-black">
                        {{ biaya.main_data.keterangan }}
                    </div>
                </div>

                <div
                    v-if="biaya.main_data.status === 1 && validateAccess('expensesWorkshop.confirm')"
                    class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
                    style="position: fixed; bottom: 64px"
                >
                    <div class="btn_actions col-md-6 col-sm-6 col-6 pr-1">
                        <SOButton :outline="true" :full="true" :text="'Tolak'" @action="tolak" />
                    </div>
                    <div class="btn_actions col-md-6 col-sm-6 col-6 pl-1">
                        <SOButton :primary="true" :full="true" :text="'Setujui'" @action="setujui" />
                    </div>
                </div>
                <div
                    v-if="biaya.main_data.status !== 1 && validateAccess('expensesWorkshop.delete')"
                    class="d-flex align-items-center btn_action_wrapper col-md-12 col-sm-12 col-12 p-0 bg-white"
                    style="position: fixed; bottom: 70px"
                >
                    <div class="btn_actions col-md-12 col-sm-12 col-12">
                        <SOButton :outline-danger="true" :full="true" :text="'Hapus'" @action="onDelete" />
                    </div>
                </div>
            </div>

            <div class="modal" tabindex="-1" role="dialog" :id="modalId">
                <div class="modal-dialog m-0" role="document">
                    <div class="modal-content" style="border-radius: 0">
                        <div
                            class="modal-body p-0 vh-100 d-flex justify-content-center align-items-center"
                            style="background-color: black;"
                        >
                            <img
                                src="@/assets/icons/close-white.svg"
                                alt=""
                                style="position:absolute; top: 20px; left: 20px; border-radius: 50%; background-color: #00000080"
                                @click="previewPhotoClose"
                            />
                            <iframe
                                v-if="fileContentType.includes('video')"
                                style="width: 100vw; height: 100vh"
                                :src="fileUrl"
                                title="description"
                            ></iframe>
                            <img v-else :src="fileUrl" class="w-100" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </SOSlotBase>
</template>

<script>
import { mapGetters } from "vuex";
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "BiayaWorkshopDetail",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOButton,
    },
    computed: {
        ...mapGetters("biayaWorkshopModule", {
            biaya: "getBiayaWorkshopDetail",
        }),
    },
    data() {
        return {
            pageSetting: {
                pageTitle: "Detail Pengeluaran Biaya",
                loading: false,
            },
            baseUrlCloudBucket: "https://storage.googleapis.com/",
            fileUrl: "",
            fileContentType: "",
            modalId: "modal-preview-" + Math.floor(Math.random() * 10000).toString(),
            isNotification: false
        };
    },
    mounted() {

        this.isNotification = this.$route.query.is_notification == "1"
        this.idbiaya = this.$route.params.id;
        this.detail();
        if(this.biaya.main_data.status===1){
            this.smartTrackingView("konfirmasi_biaya_workshop");
        }else{
            this.smartTrackingView("detail_biaya_workshop");
        }
    },
    methods: {
        back() {
            this.$router.back();
        },
        async detail() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("biayaWorkshopModule/fetchBiayaWorkshopDetail", this.idbiaya);
            this.pageSetting.loading = false;
            if (!res.success) {
                this.$toast.error(res.err);
            }
        },
        previewPhoto(selectedPhoto, contentType) {
            this.fileUrl = selectedPhoto;
            this.fileContentType = contentType;
            $("#" + this.modalId).modal("show");
        },
        previewPhotoClose() {
            $("#" + this.modalId).modal("hide");
            this.fileUrl = "";
            this.fileContentType = "";
        },
        closePreview() {
            this.pageSetting.fullSize = false;
        },
        tolak() {
            this.$router.push({ name: "BiayaWorkshop.Detail.Tolak", params: {isNotification: this.isNotification} });
            this.smartTrackingClick("tolak_biaya_wokshop");
        },
        setujui() {
            this.$router.push({ name: "BiayaWorkshop.Detail.Setuju", params: {isNotification: this.isNotification} });
            this.smartTrackingClick("setuju_biaya_workshop");
        },
        onDelete() {
            this.$router.push({ name: "BiayaWorkshop.Detail.delete" });
            this.smartTrackingClick("hapus_biaya_workshop");
        },
    },
};
</script>

<style scoped>
.card-biaya {
    border: 1px solid #c8d0dd;
    border-radius: 4px;
    padding: 10px 18px;
}

.img-wrapper {
    display: flex;
    flex-wrap: wrap;
}

.img-container {
    width: fit-content;
    padding: 8px;
}

.img-container .img-biaya {
    border: 1px solid #c8d0dd;
    border-radius: 5px;
}

.biaya-disetujui {
    background-color: #e8fcee;
}

.biaya-ditolak {
    background-color: #fff1f1;
}

#img-preview {
    position: fixed;
    width: 100vw;
    top: 50%;
    transform: translateY(-50%);
}
</style>
